import {
  createDirectus,
  rest,
  authentication,
  readItems,
  createItem,
  updateItem,
  deleteItem,
  readItem,
} from "@directus/sdk";

const client = createDirectus(location.origin)
  .with(authentication("cookie"))
  .with(rest());

async function get(filter, deep) {
  let obj = { fields: ["*"] };
  if (filter) obj.filter = filter;
  if (deep) obj.deep = deep;
  const data = await client.request(readItems("message_threads", obj));

  return data;
}

async function getById(id) {
  const data = await client.request(
    readItem("message_threads", id, {
      fields: ["*"],
    })
  );

  return data;
}
async function create(data) {
  return await client.request(createItem("message_threads", data));
}

async function updateById(id, data) {
  return await client.request(updateItem("message_threads", id, data));
}

async function deleteById(id) {
  return await client.request(deleteItem("message_threads", id));
}
export default {
  get,
  create,
  deleteById,
  getById,
  updateById,
};
